"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActivationReviewNaturalDisasterContainer = void 0;
var _CallAPI = require("01_core/components/system/CallAPI");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _ActivationReviewNaturalDisaster = _interopRequireDefault(require("./ActivationReviewNaturalDisaster"));
var _activationReviewNaturalDisasterActions = require("./activationReviewNaturalDisasterActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ドキュメント管理（発動後レビュー、自然災害）
 */
class ActivationReviewNaturalDisasterContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    props.initDisplay(props.selectSiteKindCd);
  }
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_ActivationReviewNaturalDisaster.default, {
      isNewWindow: this.props.isNewWindow
    });
  }
}
exports.ActivationReviewNaturalDisasterContainer = ActivationReviewNaturalDisasterContainer;
ActivationReviewNaturalDisasterContainer.propTypes = {
  selectSiteKindCd: _propTypes.default.string
};
const mapDispatchToProps = dispatch => {
  return {
    initDisplay: selectSiteKindCd => dispatch(_activationReviewNaturalDisasterActions.activationReviewNaturalDisasterActions[_activationReviewNaturalDisasterActions.TYPES.INIT_DISPLAY](selectSiteKindCd)),
    clear: () => dispatch(_activationReviewNaturalDisasterActions.activationReviewNaturalDisasterActions[_activationReviewNaturalDisasterActions.TYPES.CLEAR]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _CallAPI.withCallAPI)(ActivationReviewNaturalDisasterContainer));